import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { normalizeBookingLanguage } from '../config/i18n';
import { resolveUiLanguageForPath } from '../config/uiLanguageFromUrl';
import { syncPreferredLanguageToBackend } from '../utils/syncPreferredLanguage';

/** Langue UI : préfixe URL (/en, /es, …) ; absence de préfixe = fr (#1120, #1093). */
export default function LocaleRouteSync() {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const target = resolveUiLanguageForPath(location.pathname);
    if (normalizeBookingLanguage(i18n.language) !== target) {
      void i18n.changeLanguage(target).then(() => {
        void syncPreferredLanguageToBackend(target);
      });
    }
  }, [location.pathname, i18n]);

  return null;
}
